import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

export default function ContentGrid() {
  const hotComics = comics.filter((c) => c.isHot).slice(0, 4);
  const recommendedComics = comics.filter((c) => c.isRecommended).slice(0, 4);
  const latestComics = comics.slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100" aria-labelledby="content-title">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-foreground-500">
              热门推荐
            </span>
            <h2
              id="content-title"
              className="mt-2 text-2xl md:text-4xl font-heading text-foreground-950"
            >
              大家都在看
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            精选优质国漫，每日更新，追更不等待
          </p>
        </div>

        {/* Featured Card */}
        <div className="mb-10">
          {hotComics.length > 0 && (
            <ComicCard {...hotComics[0]} variant="featured" />
          )}
        </div>

        {/* Hot Comics Grid */}
        <div className="mb-14">
          <h3 className="text-lg font-heading text-foreground-900 mb-5">🔥 热门连载</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {hotComics.map((comic) => (
              <ComicCard key={comic.id} {...comic} />
            ))}
          </div>
        </div>

        {/* Recommended Grid */}
        <div className="mb-14">
          <h3 className="text-lg font-heading text-foreground-900 mb-5">⭐ 编辑推荐</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {recommendedComics.map((comic) => (
              <ComicCard key={comic.id} {...comic} />
            ))}
          </div>
        </div>

        {/* Latest Updates */}
        <div>
          <h3 className="text-lg font-heading text-foreground-900 mb-5">🆕 最近更新</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {latestComics.map((comic) => (
              <ComicCard key={comic.id} {...comic} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}